<template lang="pug">
RouterView
</template>

<script>
export default {
	name: 'App'
}
</script>
